import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Player } from "@lottiefiles/react-lottie-player";
import lottieNoData from "../../assets/lotties/noData.json";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container className="py-5 text-center my-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <div className="p-4 p-md-5 rounded shadow-sm bg-white border">
            <Player
              src={lottieNoData}
              loop
              autoplay
              style={{ height: "220px", width: "220px" }}
            />
            <h1
              className="mt-4 mb-3"
              style={{
                fontFamily: "var(--primary-font-semibold)",
                color: "#1a1a1a",
                fontSize: "2rem",
                fontWeight: 700,
              }}
            >
              {t("notFound.title", "404 - Page Not Found")}
            </h1>
            <p
              className="text-muted mb-4"
              style={{
                fontFamily: "var(--primary-font-medium)",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              {t(
                "notFound.description",
                "Oops! The page you are looking for does not exist or has been moved."
              )}
            </p>
            <Button
              className="btnBlue px-4 py-2"
              onClick={() => navigate("/")}
              style={{
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              {t("notFound.backToHome", "Back to Home")}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
